import React from "react";
import {
  PsrCaptureProfile
} from "../../../../Model/CaptureProfile";
import { PsrCameraState } from "../../../../Model/ModuleState";
import { BaseControl } from "../../../Imager/ImagerFeatureControls";

type Props = {
  psrCameraState: PsrCameraState;
  captureProfile: PsrCaptureProfile;
  disabled: boolean;
};

export function PsrImageInfoControl({ psrCameraState, captureProfile, disabled }: Props) {
  if (captureProfile.exposure == null) {
    throw new Error("Capture profile exposure is null");
  }

  const imageMP = ((psrCameraState.imageWidth * psrCameraState.imageHeight) / 1000000).toFixed(1).toString();
  return (
    <BaseControl key="imagerInfo" id="imagerInfo" disabled={disabled}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color: disabled ? "#808080" : "#2F80ED",
          textAlign: "center",
          flexGrow: 1,
        }}
      >
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M33 24C33 28.9706 28.9706 33 24 33C19.0294 33 15 28.9706 15 24C15 19.0294 19.0294 15 24 15C28.9706 15 33 19.0294 33 24ZM22.7143 21.8571H25.2857V29.5714H22.7143V21.8571ZM25.2858 18.4286H22.7143V21H25.2858V18.4286Z"
            fill="#2F80ED"
          />
        </svg>

        <div
          style={{
            margin: "0px 15px 0px 15px",
            fontSize: "14px",
            lineHeight: "16px",
          }}
        >
          {"Image Size: " + psrCameraState.imageWidth + "px x " + psrCameraState.imageHeight + "px (" + imageMP + " MP)"}
          <br />
          {"Applied Exposure: " + captureProfile.exposure?.toFixed(2) + " ms"}
        </div>
        <div
          style={{
            width: 48,
            height: 48,
          }}
        />
      </div>
    </BaseControl>
  );
}
